class SingleReview extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.boundHandleClick = this.handleClick.bind(this)
    this.link = this.querySelector('[data-review-link]')
    this.link?.addEventListener('click', this.boundHandleClick)
  }

  disconnectedCallback() {
    this.link?.removeEventListener('click', this.boundHandleClick)
  }

  handleClick(event) {
    const href = event.currentTarget.getAttribute('href')
    if (href && href.startsWith('#')) {
      event.preventDefault()
      const targetElement = document.querySelector(href)
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: 'smooth',
        })
      }
    }
  }
}

customElements.define('single-review', SingleReview)
